import { createAsyncThunk } from '@reduxjs/toolkit';
import config from "../../../constants/config.json";
import  ServerConfig  from "../../../constants/config.js"; 

export const apiThunkForSupportModal = createAsyncThunk(
  'support/createTicketWithAttachment',
  async (
    { ticketTitle, fullDescription, formData }, 
    { rejectWithValue  , getState}
  ) => {
    let ticketId = null;
    const DEV_SERVER_URL = ServerConfig.SERVER_URL;
    const OPENPROJECT_PROJECT_ID = config.OPENPROJECT_PROJECT_ID;
    const OPENPROJECT_TICKET_TYPE_ID = config.OPENPROJECT_TICKET_TYPE_ID;
    try {
     const state = getState();
      const token = state.auth?.token;

     const baseHeaders = {
          'Content-Type': 'application/json',
    };
       const uploadHeaders = {};
        if (token) {
          uploadHeaders['Authorization'] = `Bearer ${token}`;
        }

      if (token) {
          baseHeaders.Authorization = `Bearer ${token}`;
        }
      console.log('[Ticket Creation] Starting...', { ticketTitle });

      const ticketRes = await fetch(`${DEV_SERVER_URL}/api/support/ticket`, {
        method: "POST",
        body: JSON.stringify({
          subject: ticketTitle,
          description: { format: "markdown", raw: fullDescription },
          _links: {
            type: { href: `/api/v3/types/${OPENPROJECT_TICKET_TYPE_ID}` },
            project: { href: `/api/v3/projects/${OPENPROJECT_PROJECT_ID}` },
          },
        }),
         headers :baseHeaders,

      });

      if (!ticketRes.ok) {
        const errorData = await ticketRes.json().catch(() => ({}));
        console.error(`[Ticket Creation Failed] Status: ${ticketRes.status}`, errorData);

        return rejectWithValue({
          step: 'createTicket',
          status: ticketRes.status,
          message: errorData.message || `Échec de création du ticket (HTTP ${ticketRes.status})`,
          ...errorData,
        });
      }

      const ticketData = await ticketRes.json();
      ticketId = ticketData.id;
      console.log(`[Ticket Created] ID: ${ticketId}`, ticketData);

      // ÉTAPE 2 : Uploader la pièce jointe (si fournie)
      if (formData) {
        console.log(`[Attachment Upload] Starting for ticket ${ticketId}...`);

        const uploadRes = await fetch(`${DEV_SERVER_URL}/api/support/ticket/${ticketId}/attachment`, {
          method: "POST",
          body: formData,
          headers : uploadHeaders ,

        });

        if (!uploadRes.ok) {
          const errorData = await uploadRes.json().catch(() => ({}));
          console.error(`[Upload Failed] Status: ${uploadRes.status} for ticket ${ticketId}`, errorData);

          return rejectWithValue({
            step: 'uploadAttachment',
            ticketId,
            status: uploadRes.status,
            message: errorData.message || `Échec de l'upload (HTTP ${uploadRes.status})`,
            ...errorData,
          });
        }

        const attachmentData = await uploadRes.json().catch(() => null);
        console.log(`[Attachment Uploaded] for ticket ${ticketId}`, attachmentData);

        return {
          ticket: ticketData,
          attachment: attachmentData,
          success: true,
        };
      }

      // Si pas de fichier, on renvoie juste le ticket
      return {
        ticket: ticketData,
        attachment: null,
        success: true,
      };

    } catch (error) {
      console.error(`[Unexpected Error] in workflow for ticket ${ticketId || 'unknown'}:`, error);

      return rejectWithValue({
        step: 'unknown',
        ticketId,
        message: error.message || 'Erreur réseau ou inattendue',
        name: error.name,
        stack: process.env.NODE_ENV === 'development' ? error.stack : undefined,
      });
    }
  }
);